import React from "react";
import SkuList from "./SkuList";

const SkuMaster = () => (
  <div className="container-fluid py-2">
    <SkuList />
  </div>
);

export default SkuMaster;
